export const FilledGreenWiteTick = ({
  size = "14",
  ...props
}: {
  size?: string;
} & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="14" height="14" rx="7" fill="#24843F" />
    <g clipPath="url(#clip0_6252_20931)">
      <path
        d="M5.76018 9.52658C5.56148 9.52667 5.37092 9.44769 5.23053 9.30707L3.62923 7.70636C3.45692 7.534 3.45692 7.25461 3.62923 7.08225C3.80158 6.90995 4.08097 6.90995 4.25333 7.08225L5.76018 8.58911L9.74667 4.60261C9.91903 4.43031 10.1984 4.43031 10.3708 4.60261C10.5431 4.77497 10.5431 5.05436 10.3708 5.22672L6.28983 9.30707C6.14944 9.44769 5.95888 9.52667 5.76018 9.52658Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_6252_20931">
        <rect
          width="7"
          height="7"
          fill="white"
          transform="translate(3.5 3.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
